import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/mh200/h5/');

export default function MhKh5({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('waveportableairconditioner');

    return (
        <div className={`${css.mhKh5} mhKh5`}>
            <div className="ms-box1">
                <div className="ms-box-move1">
                    <div className="msg-a-title1">{t('mh200.mhE_ms1')}</div>
                    <div className="msg-a-title2">{t('mh200.mhE_ms2_h5')}</div>
                </div>
            </div>
            <div className="img-canvas img-canvas1">
                <div className="img-size img-size1">
                    <EFPic name={["aniA1.webp", "aniA1.png"]} className="fullImgs" />
                </div>
                <div className="img-size img-size2">
                    <EFPic name={["aniA2.webp", "aniA2.png"]} className="fullImgs" />
                </div>
            </div>
            <div className="ms-box-2 ms-box-2-1">
                <div className="msg-a-title3">
                    {t.rich('mh200.mhE_ms3', {
                        line1: (text: any) => <span className="color-ms1">{text}</span>,
                    })}
                </div>
            </div>
            <div className="img-canvas img-canvas2">
                <div className="img-size img-size1">
                    <EFPic name={["aniC1.webp", "aniC1.png"]} className="fullImgs" />
                </div>
                <div className="ms-unit-line">{t('mh200.mhE_ms4')}</div>
            </div>
            <div className="ms-box-2 ms-box-2-2">
                <div className="msg-a-title3">{t('mh200.mhE_ms5')}</div>
            </div>
        </div>
    );
}
